import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationFormApi } from 'api/applicationForm';

export const useApplicationInProgressById = (applicationId: string): UseQueryResult<any> =>
  useQuery(
    ['application-in-progress', applicationId],
    () => (applicationId ? applicationFormApi.getApplicationInProgress(applicationId) : null),
    {
      enabled: !!applicationId,
    },
  );
